<ndt-register-view
   [name]="name"
   [totalCount]="totalCount"
   [callState]="callState"
   [hasNextPage]="hasNextPage"
   [searchText]="searchText"
   [pagingCallState]="pagingCallState"
   (loadMore)="onLoadMore()"
   (quickFilterChange)="onQuickFilterChange($event)"
>
   <ndt-register-quick-filter>
      <mat-form-field>
         <mat-label>Filter by type</mat-label>
         <input
            [lcsSingleSelect]="deviceTypeSelect"
            ndtDeviceTypeSelect
            autocomplete="off"
            type="text"
            [ngModel]="selectedDeviceType"
            (ngModelChange)="onDeviceTypeSelected($event)"
            id="extension-type"
         />
         <ndt-device-type-select #deviceTypeSelect [isIncludeEmptyOption]="true"></ndt-device-type-select>
      </mat-form-field>
      <mat-slide-toggle
         class="quick-filter-checkbox"
         [ngModel]="hideUsedDevices"
         (ngModelChange)="toggleHideUsedDevices($event)"
         id="user-hide-used-phones"
         color="primary"
      >
         <mat-label>Hide Used Phones </mat-label>
      </mat-slide-toggle>
      <mat-slide-toggle
         class="quick-filter-checkbox"
         [ngModel]="showDevicesWithIssues"
         (ngModelChange)="toggleShowDevicesWithIssues($event)"
         id="filter-by-issues"
         color="primary"
      >
         <mat-label>Phones with Issues </mat-label>
      </mat-slide-toggle>
   </ndt-register-quick-filter>
   <lcs-responsive-table [columns]="columns">
      <table #table lcs-table [dataSource]="dataSource">
         <tr lcs-header-row *lcsResponsiveHeaderRowDef></tr>
         <tr lcs-row *lcsResponsiveRowDef></tr>
         <ng-container lcsColumnDef="deviceModel" [width]="4">
            <th
               class="register-column-header"
               lcs-header-cell
               *lcsHeaderCellDef
               id="deviceModel-column-header"
               ndtSortColumn
               (emitter)="onOrderingOptionsChange($event)"
               [attr.sortDirection]="getOrderingOption(orderingOptions, 'deviceType.name')"
               sortField="deviceType.name"
               >Model<mat-icon class="mat-icon-sort">{{ getSort('deviceType.name') }}</mat-icon></th
            >
            <td lcs-cell *lcsCellDef="let device" class="phone-issues-chip-and-menu">
               <a [routerLink]="getRouterLink(device.deviceId)">
                  {{ device.deviceModel }}
               </a>
               @if (device.isHacked || device.isFraud) {
               <phone-issues-chip-and-menu [device]="device"></phone-issues-chip-and-menu>
               }
            </td>
         </ng-container>
         @if (!hideUsedDevices) {
         <ng-container lcsColumnDef="extension" [width]="5">
            <th
               lcs-header-cell
               *lcsHeaderCellDef
               id="extension-column-header"
               ndtSortColumn
               (emitter)="onOrderingOptionsChange($event)"
               [attr.sortDirection]="getOrderingOption(orderingOptions, 'phone.extension.number')"
               sortField="phone.extension.number"
               >Extension<mat-icon class="mat-icon-sort">{{ getSort('phone.extension.number') }}</mat-icon></th
            >
            <td lcs-cell *lcsCellDef="let device">
               <a [routerLink]="getRouterLink(device.deviceId)">
                  {{ device.phoneExtension?.number }}
               </a>
            </td>
         </ng-container>
         }
         <ng-container lcsColumnDef="macAddress" [width]="6">
            <th
               class="register-column-header"
               lcs-header-cell
               *lcsHeaderCellDef
               id="macAddress-column-header"
               ndtSortColumn
               (emitter)="onOrderingOptionsChange($event)"
               [attr.sortDirection]="getOrderingOption(orderingOptions, 'macAddress')"
               sortField="macAddress"
               >Mac Address<mat-icon class="mat-icon-sort">{{ getSort('macAddress') }}</mat-icon></th
            >
            <td lcs-cell *lcsCellDef="let device">
               @if (!device.macAddress) {
               <a [routerLink]="getRouterLink(device)" class="sip-username-container">
                  {{ device.macAddress }}
               </a>
               } @if (device.macAddress) {
               <a [routerLink]="getRouterLink(device.deviceId)" class="sip-username-container">
                  <div class="mac-sip-wrapper">
                     <mat-icon
                        class="small-icon"
                        (click)="
                           copyMacAddressToClipboard(device.macAddress);
                           $event.preventDefault();
                           $event.stopPropagation()
                        "
                     >
                        content_copy
                     </mat-icon>
                     <span class="" spanTitleIfOverflow>{{ device.macAddress }}&nbsp;</span>
                  </div>
               </a>
               }
            </td>
         </ng-container>
         <ng-container lcsColumnDef="sipUser" [width]="7">
            <th
               lcs-header-cell
               *lcsHeaderCellDef
               id="sipUser-column-header"
               ndtSortColumn
               (emitter)="onOrderingOptionsChange($event)"
               [attr.sortDirection]="getOrderingOption(orderingOptions, 'phone.sipusers.userName')"
               sortField="phone.sipusers.userName"
               >Sip Username<mat-icon class="mat-icon-sort">{{ getSort('phone.sipusers.userName') }}</mat-icon></th
            >
            <td lcs-cell *lcsCellDef="let device">
               @if (!device.sipUsers?.[0]?.userName) {
               <a [routerLink]="getRouterLink(device.deviceId)"> &nbsp; </a>
               } @if (device.sipUsers?.[0]?.userName) {
               <a [routerLink]="getRouterLink(device.deviceId)" class="sip-username-container">
                  <div class="mac-sip-wrapper">
                     @if (device.sipUsers?.[0]?.userName) {
                     <mat-icon
                        class="small-icon"
                        (click)="copySipUsernameToClipboard(device); $event.preventDefault(); $event.stopPropagation()"
                     >
                        content_copy
                     </mat-icon>
                     }
                     <span class="sip-text" spanTitleIfOverflow> {{ device.sipUsers?.[0]?.userName}}&nbsp; </span>
                  </div>
               </a>
               }
            </td>
         </ng-container>
         <ng-container lcsColumnDef="lastDateProvisioned" [width]="6.5">
            <th
               class="register-column-header"
               lcs-header-cell
               *lcsHeaderCellDef
               id="lastDateProvisioned-column-header"
               ndtSortColumn
               (emitter)="onOrderingOptionsChange($event)"
               [attr.sortDirection]="getOrderingOption(orderingOptions, 'lastProvisionedDate')"
               sortField="lastProvisionedDate"
               >Last Provisioned<mat-icon class="mat-icon-sort">{{ getSort('lastProvisionedDate') }}</mat-icon></th
            >
            <td lcs-cell *lcsCellDef="let device">
               <a [routerLink]="getRouterLink(device.deviceId)">
                  {{ device.lastProvisioned | date : 'MM/dd/yyyy hh:mm aa' }}
               </a>
            </td>
         </ng-container>
         <ng-container lcsColumnDef="defaultPhoneNumber" [width]="8">
            <th
               class="register-column-header"
               lcs-header-cell
               *lcsHeaderCellDef
               id="defaultPhoneNumber-column-header"
               ndtSortColumn
               (emitter)="onOrderingOptionsChange($event)"
               [attr.sortDirection]="
                  getOrderingOption(orderingOptions, 'phone.extensionPhone.defaultPhoneNumber.phoneNumber')
               "
               sortField="phone.extensionPhone.defaultPhoneNumber.phoneNumber"
               >Default Phone Number<mat-icon class="mat-icon-sort">{{
                  getSort('phone.extensionPhone.defaultPhoneNumber.phoneNumber')
               }}</mat-icon></th
            >
            <td lcs-cell *lcsCellDef="let device">
               <a [routerLink]="getRouterLink(device.deviceId)">
                  {{ device.defaultPhoneNumber | formatPhoneNumbers }}
               </a>
            </td>
         </ng-container>
         <ng-container lcsColumnDef="ztpRegistered" [width]="3.5">
            <th
               class="register-column-header"
               lcs-header-cell
               *lcsHeaderCellDef
               id="ztpRegistered-column-header"
               ndtSortColumn
               (emitter)="onOrderingOptionsChange($event)"
               [attr.sortDirection]="getOrderingOption(orderingOptions, 'ztStatus')"
               sortField="ztStatus"
               >ZT<mat-icon class="mat-icon-sort">{{ getSort('ztStatus') }}</mat-icon></th
            >
            <td lcs-cell *lcsCellDef="let device">
               <a [routerLink]="getRouterLink(device.deviceId)">
                  @if (device.ztStatus) {
                  <mat-icon>check</mat-icon>
                  }
               </a>
            </td>
         </ng-container>
         <ng-container lcsColumnDef="connectionStatus" [width]="6">
            <th lcs-header-cell *lcsHeaderCellDef id="connectionStatus-column-header">Connection</th>
            <td lcs-cell *lcsCellDef="let device">
               <a [routerLink]="getRouterLink(device.deviceId)">
                  @if (device.isConnected) {
                  <div [style.color]="'green'">Connected</div>
                  } @else { Disconnected }
               </a>
            </td>
         </ng-container>
         <ng-container lcsColumnDef="lastConnected" [width]="6.5">
            <th lcs-header-cell *lcsHeaderCellDef id="lastConnected-column-header">Last Connection</th>
            <td lcs-cell *lcsCellDef="let device">
               <a [routerLink]="getRouterLink(device.deviceId)">
                  {{ device.lastConnected | date : 'MM/dd/yyyy hh:mm aa' }}
               </a>
            </td>
         </ng-container>
         <ng-container lcsColumnDef="devicesActionsMenu" [width]="3">
            <th lcs-header-cell *lcsHeaderCellDef id="devices-actions-menu-column-header"></th>
            <td lcs-cell *lcsCellDef="let device">
               <button
                  type="button"
                  aria-label="Device Actions"
                  matTooltip="More Actions"
                  mat-icon-button
                  [matMenuTriggerFor]="devicesMenu"
                  [matMenuTriggerData]="{ $implicit: device }"
                  id="device-detail-more-actions"
               >
                  <mat-icon> more_horiz </mat-icon>
               </button>
               <mat-menu #devicesMenu="matMenu">
                  <a mat-menu-item [routerLink]="getRouterLink(device.deviceId)"> Details </a>
                  @if (device.phoneExtension?.extensionId) {
                  <a mat-menu-item [routerLink]="getDeviceExtensionRouterLink(device)">Extension Details</a>
                  }
                  <button type="button" mat-menu-item (click)="copyMacAddressToClipboard(device.macAddress)">
                     Copy MAC Address
                  </button>
                  <button type="button" mat-menu-item (click)="copySipUsernameToClipboard(device)">
                     Copy Sip Username
                  </button>
                  @if ((device?.sipUsers?.[0]?.internalIps || device?.sipUsers?.[0]?.externalIps) ||
                  (device?.sipUsers?.[0]?.phone?.adminPassword ||
                  device?.basestationHandsets?.[0]?.phone?.adminPassword) ||
                  (device?.basestationHandsets?.[0]?.phone?.sipUsersConnection?.items[0]?.internalIps ||
                  device?.basestationHandsets?.[0]?.phone?.sipUsersConnection?.items[0]?.externalIps)) {
                  <button mat-menu-item [matMenuTriggerFor]="webInterfaceMenu"> Web Interface </button>
                  } @if (isSystemUser) {
                  <button type="button" mat-menu-item (click)="rebootPhoneClick(device)"> Reboot </button>
                  } @if (device.ztStatus === true && isSystemUser) {
                  <button type="button" mat-menu-item (click)="resetPhoneZtpClick(device)">
                     Factory Reset Phone
                  </button>
                  } @if (device.isHacked || device.isFraud) {
                  <button mat-menu-item type="button" id="devices-details" (click)="resetHackedAndFraudDevice(device)">
                     Resolve issue
                  </button>
                  } @if (canReleaseToAccount(device) || canReleaseToSystem(device) || canDeleteFromNDT(device)) {
                  <button mat-menu-item [matMenuTriggerFor]="releaseMenu"> Release / Remove </button>
                  }
                  <mat-menu #webInterfaceMenu="matMenu">
                     @if ((device?.sipUsers?.[0]?.internalIps || device?.sipUsers?.[0]?.externalIps) ||
                     (device?.basestationHandsets?.[0]?.phone?.sipUsersConnection?.items[0]?.internalIps ||
                     device?.basestationHandsets?.[0]?.phone?.sipUsersConnection?.items[0]?.externalIps)) {
                     <button mat-menu-item (click)="copyWebInterfaceUrl(device)"> Copy Web Interface URL </button>
                     }
                     <button mat-menu-item (click)="copyCurrentWebInterfacePassword(device)">
                        Copy Current Password
                     </button>
                  </mat-menu>
                  <mat-menu #releaseMenu="matMenu">
                     @if (canReleaseToAccount(device)) {
                     <button
                        mat-menu-item
                        type="button"
                        (click)="onReleaseToAccountClick(device); $event.preventDefault(); $event.stopPropagation()"
                        id="device-release-to-account"
                     >
                        Release to Account
                     </button>
                     } @if (canReleaseToSystem(device)) {
                     <button
                        mat-menu-item
                        type="button"
                        (click)="onReleaseToSystemClick(device); $event.preventDefault(); $event.stopPropagation()"
                        id="device-release-to-system"
                     >
                        Release to System
                     </button>
                     } @if (canDeleteFromNDT(device)) {
                     <button
                        mat-menu-item
                        type="button"
                        (click)="onDeleteClick(device); $event.preventDefault(); $event.stopPropagation()"
                        id="device-delete"
                     >
                        Remove from System
                     </button>
                     }
                  </mat-menu>
               </mat-menu>
            </td>
         </ng-container>
      </table>
   </lcs-responsive-table>
</ndt-register-view>
